'use strict';

exports.consoleFormat = require('./lib/console-format.js');
var isEmoji = exports.isEmoji = require('./lib/is-emoji.js');
var split = exports.split = require('./parsers/unicode-and-emoji.js').parse;

exports.withoutEmoji = function (string) {
  var result = split(string);

  if (!result) {
    return result;
  }

  return result.filter(function (symbol) {
    return !isEmoji(symbol);
  });
};

exports.onlyEmoji = function (string) {
  var result = split(string);

  if (!result) {
    return result;
  }

  return result.filter(function (symbol) {
    return isEmoji(symbol);
  });
};
